export const CSS = {
  backButton: "back-button",
};

export const ICONS = {
  backLeft: "chevron-left",
  backRight: "chevron-right",
};

export const SLOTS = {
  actionBar: "action-bar",
  contentTop: "content-top",
  contentBottom: "content-bottom",
  headerActionsStart: "header-actions-start",
  headerActionsEnd: "header-actions-end",
  headerMenuActions: "header-menu-actions",
  headerContent: "header-content",
  fab: "fab",
  footer: "footer",
  footerActions: "footer-actions",
  footerEnd: "footer-end",
  footerStart: "footer-start",
};
